import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from '../../../routes';
import Footer from '../Header_Footer/Footer';
import SideNav from '../../DeafultLayout/SideNav/SideNav';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IntializeToken } from '../../../redux/Action/Login';
import {init} from'../../../redux/Action/socketAction';
import { SideNavs } from '../SideNav/routesNavs'

class Layout extends Component {

    state = { footerHeight: 0 ,
        list:{
            items: []
        }
    
    }

    // getHeight() {
    //     let heightFo = window.innerHeight - document.getElementById("heightFooter").clientHeight;
    //     this.setState({ footerHeight: heightFo })
    // }
    // componentDidMount() { if (this.props.token) { this.getHeight() } }

    componentWillMount() {
        let type= localStorage.getItem('maktaptiType')
        if(!this.props.token){
         
            console.log("in if cond to intialize token")
            let token = localStorage.getItem('maktaptioken')
            let rule=localStorage.getItem("maktaptirules")
            if (token) {
                this.props.IntializeToken(token,rule,type)
                // this.props.IntializeToken(token)
            }
        }
        if(type !=="ADMIN"){
            let list=this.state.list
            let rule = JSON.parse(localStorage.getItem("maktaptirules"))
            list.items.push(SideNavs.items[0])
            SideNavs.items.map((element,index)=>{
                // console.log("results",index-1,rule,rule.filter(ele=>(ele.rule-35)===index-1))
    
                if(rule&&rule.filter(ele=>ele.rule===element.id).length){
                    
                //     console.log("results in if",rule.filter(ele=>(ele.rule-35)===index-1),index,element)
                return list.items.push(element)
                }
            })
            console.log("rules lat=youtttttttt",list)
            this.setState({list:list})
        }
       
        
        this.props.init()
    }



    render() {
        let height = window.innerHeight - 48;
        let token = localStorage.getItem('maktaptioken')
        let type= JSON.parse(localStorage.getItem('maktaptiType'))
        console.log("typesssssss",type,SideNavs,type==="ADMIN"?SideNavs:this.state.list)

        return (
            
            this.props.flag&&token ?
                <div>
                    <div className="App" style={{ minHeight: height }}>
                        <div> <SideNav  inputs={type ==="ADMIN"?SideNavs:this.state.list}/> </div>
                        <div className="mainBody">
                            <Switch>
                                {routes.map((route, idx) => {
                                    return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                                        <route.component {...props} />
                                    )} />)
                                        : (null);
                                },
                                )}
                                <Redirect from="/Maktapti" to="/Maktapti/dashboard" />
                            </Switch>
                        </div>
                    </div>
                    {/* <div id="heightFooter"> <Footer /> </div> */}
                </div>
                : <Redirect to="/Maktapti/login" />
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.login.token,
        flag:state.login.removeflag

    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        IntializeToken,
        init
    }
    , dispatch
)

export default (connect(mapStateToProps, mapDispatchToProps))(Layout);
